module.exports = __webpack_public_path__ + "static/img/luckDraw.0b67ddc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/integral/luckDraw.gif
// module id = TvPy
// module chunks = 1